import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/app/modules/auth/core/Auth';
import { listActive } from './_requests';

/** As empresas ativas, numa requisição só para todos os campos da tela. Com uma só, o campo some. */
export const useActiveCompanies = () => {
  const { currentUser } = useAuth();
  const queryKey = ['active-companies', currentUser?.environment_id, currentUser?.id];
  return useQuery({
    queryKey,
    queryFn: async () => {
      const response = await listActive();
      return response.data.content;
    },
  });
};
